import { store } from "../assets/store";
import { setAccessToken, clearAccessToken } from "../assets/store/auth";
import { API_URL_AUTH } from "../constants";

export async function authFetch(input: RequestInfo, init?: RequestInit, type: string = "POST") {
  const state = store.getState();
  let token = state.auth.accessToken;

  const headers = new Headers(init?.headers || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);

  let response = await fetch(input, { ...init, headers, credentials: "include" });

  // eslint-disable-next-line eqeqeq
  if (response.status == 401) {
    const refreshResp = await fetch(`${API_URL_AUTH}/refresh`, {
      method: "POST",
      credentials: "include",
    });

    if (refreshResp.ok) {
      const data = await refreshResp.json();
      token = data.accessToken;
      store.dispatch(setAccessToken(token!));

      headers.set("Authorization", `Bearer ${token}`);
      response = await fetch(input, { ...init, headers, credentials: "include" });
    } else {
      store.dispatch(clearAccessToken());
    }
  }

  return response;
}
